import { render, staticRenderFns } from "./DeletePackingDirectLinkBranch.vue?vue&type=template&id=78881078"
import script from "./DeletePackingDirectLinkBranch.vue?vue&type=script&lang=js"
export * from "./DeletePackingDirectLinkBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports